<!-- 业务流程管理 -->
<template>
  <div class='page_content'>
    <div class="page_content_top">
      <v-button :buttonList="[]" @getPageInfo="getPageInfo" :showRefresh="true" :buttonFlag="false"></v-button>
      <div class="page_content_top_line">
        <el-form :inline="true" :model="requestData" class="demo-form-inline" size="mini" label-width="100px">
          <el-form-item label="流程名称">
            <label slot="label" :style="$common.labelStyle('流程名称')" v-html="'流程名称'"></label>
            <el-input class="form_codition" v-model.trim="requestData.appName" clearable size="mini"
              placeholder="请输入流程名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="getProcessList">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-card class="box-card">
      <div class='page_content'>
        <div class="page_content_center">
          <div style="width: 100%;display: flex">
            <div class="table" style="width: 20%;">
              <div style="height: 670px;">
                <el-table size="mini" id="mxTable" :data="processList" height="100%" border
                  style="height:100%;width: 600px;margin-top:10px" highlight-current-row @row-click="changeFlow">
                  <el-table-column prop="wfdName" label="流程名称"></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="table_detail" style="width: 80%;">
              <div class="mainInfo" v-if="tabData">
                <div class="oneInfo">
                  <el-button type="primary" size="small" @click="addNewNode"
                    v-if="!tabData.appNodeUpdate || JSON.stringify(tabData.appNodeUpdate) == '[]'">添加节点
                  </el-button>
                  <div class="mainBox">
                    <div class="flowListBox" v-if="tabData.appNodeUpdate && tabData.appNodeUpdate.length > 0"
                      style="width: 250px">
                      <div class="flowBox" v-for="(flowItem, findex) in tabData.appNodeUpdate" :key="findex">
                        <div class="flowCon">
                          <i class="el-icon-circle-close clo" @click="delDom(findex, flowItem.nodeName)"></i>
                          <div class="flowtt">
                            <input v-if="flowItem.isupDate" v-model="flowItem.nodeName" @blur="blurFo(findex)" />
                            <div v-if="!flowItem.isupDate" @click="addFo(findex)" style="width:200px;height:30px;">
                              {{ flowItem.nodeName }}</div>
                          </div>
                          <div class="flowUser" @click="openEdit(findex)">
                            <span v-if="flowItem.reviewers.length > 0">{{flowItem.reviewers.map(val =>
                              val.opmName).join()
                            }}</span>
                          </div>
                        </div>
                        <div class="flowimg">
                          <img src="../../assets/xjt.png">
                        </div>
                        <img src="../../assets/add.png" class="add" @click="addDom(findex)">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="line"></div>
                <div class="oneInfo" v-if="tabData">
                  <el-form label-width="80px" class="baseForm"
                    v-if="tabData.appNodeUpdate && tabData.appNodeUpdate.length > 0 && editShow" ref="sendDataInfo"
                    size="mini" :show-message="false">
                    <el-divider content-position="left">{{ tabData.appNodeUpdate[editIndex].nodeName + ' - 节点编辑'
                    }}
                    </el-divider>
                    <el-form-item label="审批人">
                      <el-button type="primary" size="mini" @click="openPer()">编辑审批人</el-button>
                    </el-form-item>
                    <el-form-item label="审核方式">
                      <el-radio-group v-model="tabData.appNodeUpdate[editIndex].nodeType" @change="$forceUpdate()">
                        <el-radio-button label="0">任意审核</el-radio-button>
                        <el-radio-button label="1">全部审核</el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="审核意见">
                      <el-input type="textarea" :rows="4" placeholder="请输入内容"
                        v-model="tabData.appNodeUpdate[editIndex].nodeRemark" @input="updataChange">
                      </el-input>
                    </el-form-item>

                  </el-form>
                </div>
              </div>
              <div class="btn" v-if="tabData">
                <el-button type="primary" @click="subInfo">提交</el-button>
              </div>
            </div>
          </div>
        </div>
        <el-dialog title="人员列表" v-if="perDia" :visible.sync="perDia">
          <el-table :data="perList" ref="perList" border @selection-change="handleSelectionChange" height="450px"
            size="mini" v-loading="loading">
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column property="opmName" label="人员" show-overflow-tooltip></el-table-column>
            <el-table-column property="depName" label="部门" show-overflow-tooltip></el-table-column>
            <el-table-column property="reviewerCondition" label="条件(点击编辑条件)" show-overflow-tooltip>
              <template slot-scope="scope">
                <span @click="openCon(scope.row, scope.$index)"
                  style="display:block;width:100%;height:30px;background: transparent;line-height:30px;">
                  {{ scope.row.reviewerCondition }}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button @click="perDia = false">取 消</el-button>
            <el-button type="primary" @click="selPerson">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="titleName + ' - 条件编辑'" :visible.sync="regDia" width="500px">
          <el-form :model="reg" ref="reg" :rules="regRules">
            <el-form-item label="条件：" prop="reviewerCondition">
              <el-input type="textarea" :rows="4" v-model="reg.reviewerCondition" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="regDia = false" size='mini'>取 消</el-button>
            <el-button type="primary" @click="confirmReg('reg')" size="mini">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </el-card>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import {mock} from "@/api/formList.js"
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  name: "workflowSet",
  data() {
    //这里存放数据
    return {
      requestData: {
        appName: "",
      },
      processList: [],
      tabData: false,
      tindex: 0,
      findex: 0,
      info: {},
      nowIndex: "",
      perList: [],
      sendDataInfo: {},
      multipleSelection: [],
      perDia: false,
      loading: false,
      reg: {
        reviewerCondition: "",
      },
      regRules: {
        regCode: [
          { required: true, message: "请输入注册码", trigger: "blur" },
        ],
      },
      regDia: false,
      titleName: "",
      scopeIndex: 0,
      editIndex: 0,
      editShow: false,//判断是否展示右侧修改内容
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {

  },
  //方法集合
  methods: {
    //强制刷新输入框
    updataChange() {
      this.$forceUpdate()
    },
    subInfo() {
      let flag = true;
      let msg = "";
      let oneData = this.tabData.appNodeUpdate;
      for (let index = 0; index < oneData.length; index++) {
        if (oneData[index].nodeName == "") {
          flag = false;
          msg = "第" + (index + 1) + "个节点名称不能为空！";
          break;
        } else if (oneData[index].reviewers.length == 0) {
          flag = false;
          msg = oneData[index].nodeName + "节点未选择审核人！";
          break;
        }
        if (index < oneData.length - 1)
          oneData[index].appNext = oneData[index + 1].nodeId;
        if (index == oneData.length - 1) oneData[index].appNext = "";
        oneData[index].isStart = index == 0 ? 1 : 0;
        oneData[index].nodeSort = index + 1;
      }
      if (!flag) {
        return this.$message({
          type: "warning",
          message: msg,
        });
      }
      this.sub();
    },
    async sub() {
      let responseData = await this.$http.updDeinitnode(this.tabData);
      if (responseData && responseData.status == 200) {
        this.tabData = false
        this.editShow=false
        return this.$message({
          type: "success",
          message: "操作成功",
        });
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    selPerson() {
      this.tabData.appNodeUpdate[this.editIndex].reviewers = JSON.parse(JSON.stringify(this.multipleSelection)).map(item => {
        return {
          nodeId: this.tabData.appNodeUpdate[this.editIndex].nodeId,
          opmId: item.opmId,
          opmName: item.opmName,
          reviewerCondition: item.reviewerCondition,
        }
      })
      console.log(this.tabData.appNodeUpdate[this.editIndex].reviewers);
      this.perDia = false;
      this.$forceUpdate();
    },
    openEdit(index) {
      if (this.tabData.appNodeUpdate[index].nodeName == "") {
        return this.$message({
          type: "warning",
          message: "请先填写节点名称!",
        });
      }
      this.editIndex = index;
      this.editShow = true
      this.$forceUpdate();
    },
    openCon(row, index) {
      this.scopeIndex = index;
      this.titleName = row.opmName;
      this.reg.reviewerCondition = row.reviewerCondition;
      this.regDia = true;
    },
    // 确认条件
    confirmReg(reg) {
      this.$refs[reg].validate((valid) => {
        if (valid) {
          this.perList[this.scopeIndex].reviewerCondition =
            this.reg.reviewerCondition;
          this.regDia = false;
        } else {
          return false;
        }
      });
    },
    // 打开人员选择框
    openPer() {
      this.perDia = true;
      this.queryOperator();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 进入焦点
    addFo(findex) {
      this.tabData.appNodeUpdate[findex].isupDate = true;
      this.$forceUpdate();
    },
    // 移除焦点
    blurFo(findex) {
      this.tabData.appNodeUpdate[findex].isupDate = false;
      this.$forceUpdate();
    },
    // 添加节点
    addNewNode() {
      let newInfo = {
        wfdId: this.tabData.wfdId, //流程id
        nodeName: "", //节点id
        appNext: "", //下个节点名称
        nodeSort: 0, //节点排序
        nodeType: 0, //审核方式
        nodeId: this.getMath(), //节点Id
        isStart: 1, //是否开始节点
        isupDate: true, //是否编辑
        nodeRemark: "", //审核意见
        reviewers: [],
      };
      this.tabData.appNodeUpdate = [];
      this.tabData.appNodeUpdate.push(newInfo);
    },
    // 时间戳随机数 节点id
    getMath() {
      let timestamp = new Date().valueOf();
      let ran = "";
      for (var i = 0; i < 3; i++) {
        ran += Math.floor(Math.random() * 9 + 1);
      }
      return Number(timestamp + ran);
    },
    // 添加节点
    addDom(findex) {
      this.$nextTick(() => {
        let newInfo = {
          wfdId: this.tabData.wfdId, //流程id
          nodeName: "", //节点名称
          appNext: "", //下个节点id
          nodeSort: findex, //节点排序
          nodeType: 0, //审核方式
          nodeId: this.getMath(), //节点Id
          isStart: 0, //是否开始节点
          isupDate: true, //是否编辑
          nodeRemark: "", //审核意见
          reviewers: [],
        };
        this.tabData.appNodeUpdate.splice(findex + 1, 0, newInfo);
        this.editIndex = 0
        this.editShow = false
        this.$forceUpdate();
      });
    },
    // 删除节点
    delDom(findex, title) {
      this.$confirm("确认删除" + title + "节点?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          this.editIndex = 0
          this.editShow = false
          this.tabData.appNodeUpdate.splice(findex, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => { });
    },
    changeFlow(row) {
      this.tabData = {
        wfdId: row.wfdId,
        appNodeUpdate: [],
      }
      this.getNodeInfo(row.wfdId);
    },
    async getNodeInfo(id) {
      let params = {
        ids: [id],
      };
      let responseData = await this.$http.queryDeinitnode(params);
      if (responseData && responseData.status == 200) {
        this.tabData.appNodeUpdate = responseData.result;
        this.$forceUpdate();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    //查询流程列表
    async getProcessList() {
      let responseData = await this.$http.queryDeinition(this.requestData);
      if (responseData && responseData.status == 200) {
        this.processList = responseData.result;
        this.tabData = false
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    //查询人员列表
    async queryOperator() {
      this.loading = true;
      let params = {
        page: 1,
        rows: 1000,
      };
      let responseData = await this.$http.queryOperator(params);
      if (responseData && responseData.status == 200) {
        this.perList = [];
        responseData.result.list.forEach((item) => {
          this.perList.push({
            opmName: item.opmName,
            opmId: item.opmId,
            depName: item.depName,
            reviewerCondition: "",
          });
        });
        this.$nextTick(() => {
          console.log("this.perList", this.perList);
          let ids = [];
          if (this.tabData.appNodeUpdate[this.editIndex].reviewers.length > 0) {
            this.tabData.appNodeUpdate[this.editIndex].reviewers.forEach((item) => {
              ids.push({
                opmId: item.opmId,
                reviewerCondition: item.reviewerCondition,
              });
            });
          }
          this.$nextTick(() => {
            this.perList.forEach((item, index) => {
              ids.forEach((keys, i) => {
                if (item.opmId == keys.opmId) {
                  console.log(keys.opmId);
                  item.reviewerCondition = keys.reviewerCondition;
                  this.$refs.perList.toggleRowSelection(
                    this.perList[index]
                  );
                }
              });
            });
          });
          this.loading = false;
        });
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path);
      let responseData = await this.$http.getJur({
        ids: [pathId.jurId],
      });
      if (responseData.status == 200) {
        this.pageShowData = responseData.result;
        this.formDataList = this.pageShowData.jurFormVoList;
        this.getProcessList();
        // this.getButtonList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getProcessList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.el-card {
  min-height: 88vh;
  margin: 20px;
}

.el-tabs-box {
  margin-top: 20px;
}

.el-tabs__content {
  height: 90% !important;
  min-height: 70vh;
}

/* .page_content_top_line {
   margin-top: 20px;
} */

.draw {
  padding: 20px;
}

.el-select {
  width: 100%;
}

.block {
  margin-top: 20px;
}

::v-deep .el-tabs__nav .el-tabs__item:nth-child(1) span {
  display: none;
}

.flowBox {
  width: 250px;
  position: relative;
}

.flowCon {
  width: 100%;
  border-radius: 10px;
  background: #efefef;
  /* box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); */
}

.flowtt {
  width: 100%;
  height: 35px;
  color: #fff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  line-height: 35px;
  padding-left: 10px;
  background: rgb(45, 97, 240);
}

.flowUser {
  height: 70px;
  padding: 10px;
  font-size: 14px;
  overflow-y: auto;
}

.clo {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 999;
  color: #fff;
  font-size: 21px;
}

.flowimg {
  width: 100%;
  text-align: center;
}

.add {
  position: absolute;
  right: 52px;
  bottom: 18px;
  width: 30px;
}

input {
  outline: none;
  border: none;
}

.mainInfo {
  display: flex;
  justify-content: space-between;
}

.oneInfo {
  width: 48%;
  height: 72vh;
  overflow-y: auto;
}

.line {
  width: 2px;
  height: 70vh;
  border-right: 2px dashed #999;
}

.mainBox {
  display: flex;
  justify-content: center;
}

::v-deep .el-dialog__body {
  padding: 6px 20px;
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}

.btn button {
  width: 200px;
  margin-top: 10px;
}

::v-deep .el-input-group__append button.el-button {
  background-color: #409eff;
  color: #fff;
  border-top: 1;
}
</style>